(function () {
  function parseJSON() {
    var el = document.getElementById("ArticleBannersJSON");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || "[]");
    } catch (e) {
      return null;
    }
  }

  function getBlogHandle() {
    // /blogs/cbd/xxx -> cbd
    var p = window.location.pathname.split("/").filter(Boolean);
    var i = p.indexOf("blogs");
    return i >= 0 && p[i + 1] ? p[i + 1] : "";
  }

  function extractProductHandle(url) {
    try {
      var u = new URL(url, window.location.origin);
      var parts = u.pathname.split("/").filter(Boolean);
      var i = parts.indexOf("products");
      return i >= 0 && parts[i + 1] ? parts[i + 1] : "";
    } catch (e) {
      return "";
    }
  }

  function esc(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function buildBannerHTML(b, ctx) {
    var destination = b.link_url || "";
    var productHandle = extractProductHandle(destination);
    var bannerId = "blog_" + (ctx.blog_handle || "blog") + "_" + (b.id || ("idx" + b.index));

    return (
      '<p class="article-inline-banner">' +
        '<a class="article-inline-banner__link"' +
          ' href="' + esc(destination) + '"' +
          ' aria-label="' + esc(b.link_text || b.title || "Bannière") + '"' +
          ' data-banner-id="' + esc(bannerId) + '"' +
          ' data-banner-name="' + esc(b.title || "") + '"' +
          ' data-page-type="blog_article"' +
          ' data-banner-destination="' + esc(destination) + '"' +
          ' data-banner-blog-handle="' + esc(ctx.blog_handle || "") + '"' +
          ' data-banner-collection-handle=""' +
          ' data-banner-product-handle="' + esc(productHandle) + '"' +
          ' data-banner-blog-handle="' + esc(ctx.blog_handle || "") + '"' +
        '>' +
          '<img class="article-inline-banner__img"' +
            ' src="' + esc(b.img_src || "") + '"' +
            ' alt="' + esc(b.img_alt || b.title || "") + '"' +
            ' loading="lazy"' +
          '>' +
        '</a>' +
      '</p>'
    );
  }

  function replacePlaceholders(el, banners, ctx) {
    var html = el.innerHTML;

    // ✅ format principal : [banner:1], [banner:2]...
    html = html.replace(/\[banner:(\d+)\]/g, function (_, idxStr) {
      var idx = parseInt(idxStr, 10);
      var b = banners.find(function (x) { return x.index === idx; });
      return b ? buildBannerHTML(b, ctx) : "";
    });

    // ✅ fallback utile : [banner] => si une seule bannière est assignée
    html = html.replace(/\[banner\]/g, function () {
      if (banners.length === 1) return buildBannerHTML(banners[0], ctx);
      return ""; // si plusieurs, on force l'index
    });

    el.innerHTML = html;
  }

  document.addEventListener("DOMContentLoaded", function () {
    var banners = parseJSON();
    if (!banners || !banners.length) return;

    // ✅ ton DOM Horizon
    var el =
      document.querySelector(".blog-post-content.rte rte-formatter") ||
      document.querySelector(".blog-post-content.rte") ||
      document.querySelector(".rte rte-formatter") ||
      document.querySelector(".rte");

    if (!el) return;

    replacePlaceholders(el, banners, { blog_handle: getBlogHandle() });
  });
})();
